import React from "react";
import {FormControl, FormGroup} from "react-bootstrap";
import locale from "locale";
import {availableTypesBackground} from "../../EventSettings/models";
import {FORMAT_FULLPAGE, FORMATS, SCHEDULE_ORIENTATION, SCHEDULE_VIEWS} from "../constants";
import { FONTS_LIST } from '../../../../../platform/src/components/Pdf/constants';
import CPSettingRadio from "../../../UI/Settings/CPSettingRadio";
import CPSettingFont from "../../../UI/Settings/CPSettingFont";
import CPSettingColor from "../../../UI/Settings/CPSettingColor";
import CPSettingToggle from "../../../UI/Settings/CPSettingToggle";
import CPSettingSize from "../../../UI/Settings/CPSettingSize";
import CPSettingText from "../../../UI/Settings/CPSettingText";
import CPSettingImage from "../../../UI/Settings/CPSettingImage";
import CPSettingSelect from '../../../UI/Settings/CPSettingSelect';

const SettingsSidebar = ({settings, onChange}) => {
    return (
        <FormGroup>
            <CPSettingRadio
                name="view"
                eventValue={settings?.view}
                defaultValue="grid"
                label={locale('settings.view')}
                options={SCHEDULE_VIEWS}
                onChange={onChange}
            />
            {
                settings?.view === 'lines' &&
                <CPSettingToggle
                    name="episodeExpanded"
                    isChecked={settings?.episodeExpanded}
                    label={locale('settings.showEpisodeExpanded')}
                    onChange={onChange}
                />
            }
            <CPSettingSelect
                eventValue={settings?.format}
                defaultValue={'a4'}
                list={FORMATS}
                property="format"
                label={locale('settings.view')}
                onChange={onChange}
            />
            {
                settings?.format !== FORMAT_FULLPAGE &&
                <CPSettingRadio
                    name="orientation"
                    eventValue={settings?.orientation}
                    defaultValue="landscape"
                    label={locale('settings.orientation')}
                    options={SCHEDULE_ORIENTATION}
                    onChange={onChange}
                />
            }
            <CPSettingFont
                font={settings?.font}
                fonts={FONTS_LIST}
                onChange={onChange}
            />
            {/* <CPSettingImage
                name="backgroundImage"
                label={locale('settings.uploadBackground')}
                eventImageSrc={settings?.backgroundImage || ''}
                availableTypes={availableTypesBackground}
                hint={locale('settings.backgroundImageHint')}
                onChange={onChange}
            /> */}
            <CPSettingImage
                name="headerImage"
                label={locale('settings.uploadHeader')}
                eventImageSrc={settings?.headerImage || ''}
                availableTypes={availableTypesBackground}
                hint={locale('settings.backgroundImageHint')}
                onChange={onChange}
            />
            <CPSettingColor
                name="backgroundColor"
                label={locale('settings.backgroundColor')}
                eventColor={settings?.backgroundColor}
                defaultColor="#FFFFFF"
                onChange={onChange}
            />
            <CPSettingColor
                name="additionalColor"
                label={locale('settings.color.card')}
                eventColor={settings?.additionalColor}
                defaultColor={"#16161B"}
                onChange={onChange}
            />
            <CPSettingColor
                name="textColor"
                label={locale('settings.textColor')}
                eventColor={settings?.textColor}
                defaultColor={"#FFFFFF"}
                hint={locale('settings.hint.textColor')}
                onChange={onChange}
            />
            <CPSettingColor
                name="additionalTextColor"
                label={locale('settings.additionalTextColor')}
                eventColor={settings?.additionalTextColor}
                hint={locale('settings.hint.timeAndFullname')}
                defaultColor={"#454549"}
                onChange={onChange}
            />
            <CPSettingColor
                name="dateColor"
                label={locale('settings.color.date')}
                eventColor={settings?.dateColor}
                defaultColor={"#FFFFFF"}
                onChange={onChange}
            />
            <CPSettingSize
                name="elementsRoundingSize"
                label={locale('settings.elementsRounding')}
                eventValue={settings?.elementsRoundingSize}
                defaultValue={'4px'}
                onChange={onChange}
            />
            <CPSettingToggle
                name="showFormat"
                isChecked={settings?.showFormat}
                label={locale('settings.showFormatInCards')}
                onChange={onChange}
            />
            <CPSettingToggle
                name="showMembersPhoto"
                isChecked={settings?.showMembersPhoto}
                label={locale('settings.showMembersPhoto')}
                onChange={onChange}
            />
            <CPSettingToggle
                name="showMembersGroupAndName"
                isChecked={settings?.showMembersGroupAndName}
                label={locale('settings.showMembersGroupAndName')}
                onChange={onChange}
            />
            <CPSettingToggle
                name="showTags"
                label={locale('settings.showTags')}
                isChecked={settings?.showTags}
                onChange={onChange}
            />
            <CPSettingToggle
                name="showLogos"
                label={locale('settings.showLogos')}
                isChecked={settings?.showLogos}
                onChange={onChange}
            />
            <CPSettingToggle
                name="showDate"
                label={locale('settings.showDate')}
                isChecked={settings?.showDate}
                onChange={onChange}
            />
            <CPSettingSize
                name="gridCardHeightSize"
                label={locale('settings.gridCardHeight')}
                eventValue={settings?.gridCardHeightSize}
                defaultValue="6px"
                hint={locale('settings.gridCardHeightHint')}
                onChange={onChange}
            />
            <CPSettingToggle
                name="showTitle"
                isChecked={settings?.showTitle}
                label={locale('settings.showTitle')}
                onChange={onChange}
            />
            {settings?.showTitle && (
                <>
                    <CPSettingText
                        eventSetting={settings}
                        title={locale('settings.title')}
                        property="title"
                        hasToggleProperty={false}
                        defaultValue="Программа мероприятия"
                        onUpdate={onChange}
                    />
                    <CPSettingSize
                        name="titleSize"
                        label={locale('settings.titleSize')}
                        eventValue={settings?.titleSize}
                        defaultValue={'24px'}
                        onChange={onChange}
                    />
                </>
            )}
            <FormGroup>
                <FormControl
                    type="text"
                    placeholder={locale('settings.typeFileName')}
                    maxLength={50}
                    defaultValue={settings?.fileName}
                    onChange={(e) => onChange({fileName: e.target.value})}
                />
            </FormGroup>
            <h3>
                {locale('settings.delay.title')}
            </h3>
            <CPSettingToggle
                name="showDelay"
                isChecked={settings?.showDelay}
                label={locale('settings.showDelay')}
                onChange={onChange}
            />
            <CPSettingToggle
                name="delayTimeVisible"
                label={locale('settings.delay.showTime')}
                isChecked={settings?.delayTimeVisible}
                onChange={onChange}
            />
            <CPSettingToggle
                name="delayFontLarge"
                label={locale('settings.delay.largeFont')}
                isChecked={settings?.delayFontLarge}
                onChange={onChange}
            />
            <CPSettingColor
                name="delayCardColor"
                label={locale('settings.delay.cardColor')}
                eventColor={settings?.delayCardColor}
                defaultColor={"#FFFFFF"}
                onChange={onChange}
            />
        </FormGroup>
    );
};

export default SettingsSidebar;
